<template>
  <div id="imagePassportWrap">
    <imageInput v-on:imageData="imageData"  v-show="!isloading"></imageInput>
    <loader v-show="isloading"></loader>
    <div  v-show="isloading" id="awitPassportCheck">
      <h3>Пожалуйста, подождите — система распознавания проверяет ваш паспорт.</h3>
      <p>Процесс может занять до 1 минуты. Не закрывайте страницу и не перезагружайте устройство.</p>
    </div>
  </div>
</template>

<script>

export default {
  name: "instSmartId",
  data(){
    return {
      isloading:false,
      FailsCnt:0,
      smartIdKeyAlias: {
        authority: 'PASSPORT_DEP',
        authority_code: 'PASSPORT_DEP_CODE',
        birthdate: 'BIRTHDAY',
        birthplace: 'BIRTHPLACE',
        // gender: 'GENDER',
        issue_date: 'PASSPORT_DATE',
        // name: 'FIRST_NAME',
        number: 'PASSPORT_NUMBER',
        number_page2: 'PASSPORT_NUMBER',
        number_page3: 'PASSPORT_NUMBER',
        // patronymic: 'SECOND_NAME',
        series: 'PASSPORT_SERIES',
        series_page2: 'PASSPORT_SERIES',
        // surname: 'LAST_NAME',
      },
    }
  },
  components:{
    imageInput: () => import('@/components/form/imageInput.vue'),
    loader: () => import('@/views/pdlloan/uiLoader'),
  },
  methods:{
    async imageData($event) {
      this.isloading = true;
      this.$store.commit('saveWorkData', {
        target:'smartIdFileID',
        status:{
          code:0,
          msg: '',
          disable:false,
        }
      });
      this.$store.commit('saveErrorShow',{
        target:'smartIdFileID',
        value:false
      });
      const passportData = await this.$myApi.smartId($event.value);
      console.log(passportData)
      if (!(passportData?.result?.cnt > 0) && this.FailsCnt < 1) {
        this.FailsCnt+=1;
        this.$store.commit('saveWorkData', {
          target:'smartIdFileID',
          status:{
            code:500,
            msg: 'Фото не подходит: на нём не распознан паспорт.<br> Чтобы исправить это:<br>' +
                '- Паспорт в центре;<br>' +
                '- Полностью в кадре;<br>' +
                '- Без бликов и пальцев;<br>',
            disable:false,
          }
        });
        this.$store.commit('saveErrorShow',{
          target:'smartIdFileID',
          value:true
        });
        document.getElementById('stepWrap').scrollIntoView({behavior: 'smooth'});
        window.scrollBy({ top: -200, left: 0 });

      } else {
        for (let item in this.smartIdKeyAlias) {
          console.log(passportData?.result?.data[item]);
          if (passportData?.result?.data[item]) {
            this.$store.dispatch('saveSendData', {target: this.smartIdKeyAlias[item], value: passportData?.result?.data[item]});
          }
        }
        try {
          const saveFile = await this.$myApi.saveFile($event.value);
          this.$store.dispatch('saveSendData', {target: 'smartIdFileID', value: saveFile?.result?.ExecutionResult?.file_id});
        } catch (e){
          console.log(e);
        }
      }
      this.isloading = false;
    }
  }
}
</script>

<style scoped>
#imagePassportWrap{position: relative}
#awitPassportCheck{height: var(--font-size-333);text-align: center}
@media screen and (min-width: 760px) {
  #awitPassportCheck{height: var(--font-size-260);}
}
</style>